<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100">
      <defs>
        <clipPath id="clip-Twitter">
          <rect width="100" height="100"/>
        </clipPath>
      </defs>
      <g id="Twitter" clip-path="url(#clip-Twitter)">
        <g id="Groupe_3111" data-name="Groupe 3111" transform="translate(17603.371 2310.125)">
          <path id="XMLID_1_" d="M129.154,51.86a37.8,37.8,0,0,1-10.912,2.728,19.937,19.937,0,0,0,8.753-10.435c.117-.238-.238-.486-.486-.355a40.073,40.073,0,0,1-12.453,4.508,20.948,20.948,0,0,0-15.074-6.4A20.525,20.525,0,0,0,78.345,62.324a19.765,19.765,0,0,0,.593,4.624A59.046,59.046,0,0,1,36.4,45.786c0-.117-.117,0-.238,0a20.656,20.656,0,0,0-2.728,10.08,20.423,20.423,0,0,0,8.894,16.722c.117.117,0,.238-.117.238a19.839,19.839,0,0,1-8.753-2.49c-.117,0-.117,0-.117.117a25.431,25.431,0,0,0,1.425,7.474A20.515,20.515,0,0,0,49.928,90.522a20.86,20.86,0,0,1-5.456.71,18.41,18.41,0,0,1-3.676-.355.117.117,0,0,0-.117.117,20.8,20.8,0,0,0,18.964,13.994c.117,0,.117.117.117.238a41.925,41.925,0,0,1-25.383,8.539c-1.658,0-3.321-.117-4.979-.238a58.866,58.866,0,0,0,31.67,9.132,57.626,57.626,0,0,0,38.784-13.995,60.077,60.077,0,0,0,18.74-31.67,55.48,55.48,0,0,0,1.425-12.336,19.211,19.211,0,0,0-.117-2.611,41.546,41.546,0,0,0,9.725-9.608C129.747,51.976,129.392,51.738,129.154,51.86Z" transform="translate(-17632.672 -2342.025)" :fill="color"/>
        </g>
      </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconTwitter',
    mixins: [Colorable],
};
</script>
